import { db } from "../lib/firebaseApp"
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc,
    query,
    where,
    onSnapshot
} from "firebase/firestore";



/**
 * storage a category template in 
 * /SETTINGS/CATEGORY_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new template id, or UNDEFINED
*/
export const add_category_template = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "CATEGORY_CONFIG", "TEMPLATES" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_category_template:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a category template in 
 * /SETTINGS/CATEGORY_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} template_id - firebase template id
 * @param {Object} new_data - dictionary containing new template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update template 
*/
export const edit_category_template = async (user_id, template_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "CATEGORY_CONFIG", "TEMPLATES", template_id ), {
            ...new_data,
            id: template_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_category_template:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a category template in 
 * /SETTINGS/CATEGORY_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_category_template = async (user_id, template_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "CATEGORY_CONFIG", "TEMPLATES", template_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_category_template:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a category template in 
 * /SETTINGS/CATEGORY_CONFIG/TEMPLATES
 * 
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - template data or UNDEFINED
*/
export const get_category_template_byID = async (template_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "CATEGORY_CONFIG", "TEMPLATES", template_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_category_template_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a category template LIST from  
 * /SETTINGS/CATEGORY_CONFIG/TEMPLATES
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - template list
*/
export const get_category_template_list = async (cb_error) => {
    try {
        const template_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "CATEGORY_CONFIG", "TEMPLATES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const template_data = {
                ...data,
                id: doc.id,
            }
            template_list.push(template_data)
        });
        return (template_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_category_template_list:\n", error)
        }
        return([])
    }
}

//------------------------------------------CATEGORY_SECTIONS
/**
 * storage a category section in 
 * /SETTINGS/CATEGORY_CONFIG/SECTIONS
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing section parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new section id, or UNDEFINED
*/
export const add_category_section = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "CATEGORY_CONFIG", "SECTIONS" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_category_section:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a category section in 
 * /SETTINGS/CATEGORY_CONFIG/SECTIONS
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} section_id - firebase section id
 * @param {Object} new_data - dictionary containing new section parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update section 
*/
export const edit_category_section = async (user_id, section_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "CATEGORY_CONFIG", "SECTIONS", section_id ), {
            ...new_data,
            id: section_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_category_section:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a category section in 
 * /SETTINGS/CATEGORY_CONFIG/SECTIONS
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} section_id - firebase section id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_category_section = async (user_id, section_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "CATEGORY_CONFIG", "SECTIONS", section_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_category_section:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a category section in 
 * /SETTINGS/CATEGORY_CONFIG/SECTIONS
 * 
 * @param {string} section_id - firebase section id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - section data or UNDEFINED
*/
export const get_category_section_byID = async (section_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "CATEGORY_CONFIG", "SECTIONS", section_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_category_section_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a category section LIST from  
 * /SETTINGS/CATEGORY_CONFIG/SECTIONS
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - section list
*/
export const get_category_section_list = async (cb_error) => {
    try {
        const section_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "CATEGORY_CONFIG", "SECTIONS"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const section_data = {
                ...data,
                id: doc.id,
            }
            section_list.push(section_data)
        });
        return (section_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_category_section_list:\n", error)
        }
        return([])
    }
}



///--------------------------------------------------------------------------------------------------------------


/**
 * storage a award_label template in 
 * /SETTINGS/AWARD_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new template id, or UNDEFINED
*/
export const add_award_template = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "AWARD_CONFIG", "TEMPLATES" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_award_template:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a award template in 
 * /SETTINGS/AWARD_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} template_id - firebase template id
 * @param {Object} new_data - dictionary containing new template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update template 
*/
export const edit_award_template = async (user_id, template_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "AWARD_CONFIG", "TEMPLATES", template_id ), {
            ...new_data,
            id: template_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_award_template:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a award template in 
 * /SETTINGS/AWARD_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_award_template = async (user_id, template_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "AWARD_CONFIG", "TEMPLATES", template_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_award_template:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a award template in 
 * /SETTINGS/AWARD_CONFIG/TEMPLATES
 * 
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - template data or UNDEFINED
*/
export const get_award_template_byID = async (template_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "AWARD_CONFIG", "TEMPLATES", template_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_award_template_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a award template LIST from  
 * /SETTINGS/AWARD_CONFIG/TEMPLATES
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - template list
*/
export const get_award_template_list = async (cb_error) => {
    try {
        const template_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "AWARD_CONFIG", "TEMPLATES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const template_data = {
                ...data,
                id: doc.id,
            }
            template_list.push(template_data)
        });
        return (template_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_award_template_list:\n", error)
        }
        return([])
    }
}


///--------------------------------------------------------------------------------------------------------------


/**
 * storage a award_label template in 
 * /SETTINGS/AWARD_LABEL_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new template id, or UNDEFINED
*/
export const add_award_label_template = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "AWARD_LABEL_CONFIG", "TEMPLATES" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_award_label_template:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a award_label template in 
 * /SETTINGS/AWARD_LABEL_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} template_id - firebase template id
 * @param {Object} new_data - dictionary containing new template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update template 
*/
export const edit_award_label_template = async (user_id, template_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "AWARD_LABEL_CONFIG", "TEMPLATES", template_id ), {
            ...new_data,
            id: template_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_award_label_template:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a award_label template in 
 * /SETTINGS/AWARD_LABEL_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_award_label_template = async (user_id, template_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "AWARD_LABEL_CONFIG", "TEMPLATES", template_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_award_label_template:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a award_label template in 
 * /SETTINGS/AWARD_LABEL_CONFIG/TEMPLATES
 * 
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - template data or UNDEFINED
*/
export const get_award_label_template_byID = async (template_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "AWARD_LABEL_CONFIG", "TEMPLATES", template_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_award_label_template_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a award_label template LIST from  
 * /SETTINGS/AWARD_LABEL_CONFIG/TEMPLATES
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - template list
*/
export const get_award_label_template_list = async (cb_error) => {
    try {
        const template_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "AWARD_LABEL_CONFIG", "TEMPLATES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const template_data = {
                ...data,
                id: doc.id,
            }
            template_list.push(template_data)
        });
        return (template_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_award_label_template_list:\n", error)
        }
        return([])
    }
}




///--------------------------------------------------------------------------------------------------------------


/**
 * storage a award_label template in 
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new template id, or UNDEFINED
*/
export const add_match_template = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "MATCH_CONFIG", "TEMPLATES" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_match_template:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a award_label template in 
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} template_id - firebase template id
 * @param {Object} new_data - dictionary containing new template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update template 
*/
export const edit_match_template = async (user_id, template_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "MATCH_CONFIG", "TEMPLATES", template_id ), {
            ...new_data,
            id: template_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_match_template:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a award_label template in 
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_match_template = async (user_id, template_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "MATCH_CONFIG", "TEMPLATES", template_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_match_template:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a award_label template in 
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - template data or UNDEFINED
*/
export const get_match_template_byID = async (template_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "MATCH_CONFIG", "TEMPLATES", template_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_match_template_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a award_label template LIST from  
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - template list
*/
export const get_match_template_list = async (cb_error) => {
    try {
        const template_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "MATCH_CONFIG", "TEMPLATES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const template_data = {
                ...data,
                id: doc.id,
            }
            template_list.push(template_data)
        });
        return (template_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_match_template_list:\n", error)
        }
        return([])
    }
}



///--------------------------------------------------------------------------------------------------------------


/**
 * storage a award_label template in 
 * /SETTINGS/MATCH_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {Object} data - dictionary containing template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - new template id, or UNDEFINED
*/
export const add_match_complete_template = async (user_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "SETTINGS", "MATCH_COMPLETE_CONFIG", "TEMPLATES" ), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_match_complete_template:\n", error)
        }
        return(undefined)
    }
}




/**
 * edit a award_label template in 
 * /SETTINGS/MATCH_COMPLETE_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes
 * @param {string} template_id - firebase template id
 * @param {Object} new_data - dictionary containing new template parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - update template 
*/
export const edit_match_complete_template = async (user_id, template_id, new_data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "SETTINGS", "MATCH_COMPLETE_CONFIG", "TEMPLATES", template_id ), {
            ...new_data,
            id: template_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_match_complete_template:\n", error)
        }
        return(undefined)
    }
}

/**
 * edit a award_label template in 
 * /SETTINGS/MATCH_COMPLETE_CONFIG/TEMPLATES
 * 
 * @param {string} user_id - firebase user id for tracking db changes CURRENTLY NOT USED!!!!
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if there are no error
*/
export const delete_match_complete_template = async (user_id, template_id, cb_error) => {
    //TODO - delete subcollections data
    //TODO - log delete action (record user_id)
    try {
            const pivot = doc(db, "SETTINGS", "MATCH_COMPLETE_CONFIG", "TEMPLATES", template_id)
            const docSnap = await (getDoc(pivot))
            if (docSnap.exists()) {
                await deleteDoc(pivot);
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_match_complete_template:\n", error)
            }
            return(undefined)
        }
}

/**
 * retrieve a award_label template in 
 * /SETTINGS/MATCH_COMPLETE_CONFIG/TEMPLATES
 * 
 * @param {string} template_id - firebase template id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - template data or UNDEFINED
*/
export const get_match_complete_template_byID = async (template_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "SETTINGS", "MATCH_COMPLETE_CONFIG", "TEMPLATES", template_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_match_complete_template_byID:\n", error)
        }
        return(undefined)
    }
}



/**
 * retrieve a award_label template LIST from  
 * /SETTINGS/MATCH_COMPLETE_CONFIG/TEMPLATES
 * 
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {list} - template list
*/
export const get_match_complete_template_list = async (cb_error) => {
    try {
        const template_list = []
        const querySnapshot = await getDocs(collection(db, "SETTINGS", "MATCH_COMPLETE_CONFIG", "TEMPLATES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const template_data = {
                ...data,
                id: doc.id,
            }
            template_list.push(template_data)
        });
        return (template_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_match_complete_template_list:\n", error)
        }
        return([])
    }
}
